import React, { useState, useEffect } from "react";
import Layout from "../components/layout/Layout";
import { AiOutlineReload } from "react-icons/ai";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { baseURL ,Custom_jacket } from "../constants/url";
import Categories from "./Categories";
import useCategory from "../hooks/useCategory";

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const categories = useCategory();
  const [checked, setChecked] = useState([]);
  const [radio, setRadio] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [selectedCategory , setSelectedCategory] = useState("")
  const handleFilter = async() => {

    try {
      setLoading(true);
      const { data } = await axios.get(`/api/v1/product/product-filters/?id=${selectedCategory}`);
      console.log(data, "get all products");
      setLoading(false);
      setProducts([...data?.products]);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  
  useEffect(()=>{
       handleFilter()
  },[selectedCategory])

 
  return (
    <Layout title={"All Products - Best offers "}>
           <div className="d-flex justify-content-around item-center w-100 px-4 py-4 " style={{ fontWeight :700 }}>
           <p style = {{ cursor : 'pointer'}}>All</p>
           {
            categories.map((category, index) =>(
              <p style = {{ cursor : 'pointer'}} onClick={(e => {
                e.preventDefault()
                setSelectedCategory(category._id)
              })}>{category?.name}</p>
            ))
           }
           </div>
           <div className="w-100 product-styling" >
      {products?.map((p,key) =>(
        <Link key={key} to={ `/product/${p?._id}`} >
        <div className=" text-center " key={key} style={{ background : 'transparent' , width : '16rem'} }>
        <img src={`${baseURL}/api/v1/product/product-photo/${p?._id}/${0} `} className="card-img-top" alt="Product Name" style={{ width :'16rem',  height :'20rem' , objectFit: 'contain' , margin : '0 auto'}}/>
        <div className="">
            <h5 className="card-title" style = {{ fontSize :'14px'}}>{p?.name}</h5>
            <p className="card-text">${p?.designId?.custom_price}</p>
        </div> 
        </div>
        </Link>
      ))}
    
    </div>
              {/* {products && products.length < total && (
                <button
                  className="btn loadmore btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setPage(page + 1);
                  }}
                >
                      Load more <AiOutlineReload />
                </button>
              )} */}
        
          
    </Layout>
  );
};

export default AllProducts;
